import { usePageMeta } from '@/hooks/usePageMeta';
import { useLocation } from 'react-router-dom';
import ContactHeader from './components/ContactHeader';
import ContactForm from './components/ContactForm';

export default function Contact() {
  const location = useLocation();

  usePageMeta(
    'Contact Keaton Brown | Performance & Teaching Inquiries',
    'Get in touch with Keaton Brown for performance bookings, teaching engagements, and professional inquiries. Baritone based in Houston, Texas.'
  );

  return (
    <main>
      <ContactHeader />
      <ContactForm />
    </main>
  );
}